import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress, } from '@mui/material';
import { formatDistanceStrict, differenceInMilliseconds, intervalToDuration, formatDuration } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { withStyles } from '@mui/styles';

const CountdownProgressBar = ({ targetDate, setElaspTimeOver, data }) => {
  const [percentage, setPercentage] = useState(0);
  const [remainingTime, setRemainingTime] = useState('');
  const [elapsedTime, setElapsedTime] = useState('');

  const timeZone = 'Pacific/Guam'; // Chamorro Standard Time

  const addFiveDays = (dateString) => {
    let date = new Date(dateString);
    date.setDate(date.getDate() + 5);
    let newDateString = date.toISOString();
    return newDateString
  };

  const isGreaterThan5Days = (start, end) => {
    const millisecondsInDay = 1000 * 60 * 60 * 24;
    const differenceInMs = differenceInMilliseconds(end, start);
    const differenceInDays = differenceInMs / millisecondsInDay;
    return differenceInDays > 5;
  };

  const calculatePercentage = () => {
    const now = utcToZonedTime(new Date(), timeZone);
    const target = new Date(addFiveDays(targetDate));
    const totalDuration = target - now;
    const elapsedDuration = now - new Date(targetDate);

    if (totalDuration <= 0) {
      setPercentage(100);
      setRemainingTime('0d 0h');
      setElapsedTime('Elapsed Time: ' + formatDuration(intervalToDuration({ start: target, end: now }), { format: ['days', 'hours'] }));
      if (isGreaterThan5Days(target, now)) setElaspTimeOver(true)
    } else {
      const remainingDuration = intervalToDuration({ start: now, end: target });
      const elapsedDurationObj = intervalToDuration({ start: new Date(targetDate), end: now });

      setRemainingTime('Remaining Time: ' + formatDuration(remainingDuration, { format: ['days', 'hours'] }));
      setElapsedTime('Elapsed Time: ' + formatDuration(elapsedDurationObj, { format: ['days', 'hours'] }));
      if (isGreaterThan5Days(new Date(targetDate), now)) setElaspTimeOver(true)
      setPercentage((elapsedDuration / (totalDuration)) * 100);
    }
  };

  useEffect(() => {
    const interval = setInterval(calculatePercentage, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  const AnimatedLinearProgress = withStyles((theme) => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: '#ffcccb',
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#1a90ff',
      transition: 'width 1s linear',
    },
  }))(LinearProgress);

  return (
    <Box display="flex" flexDirection="column" width="60%">
      {/* <Typography variant="h6">Countdown to {targetDate}</Typography>
      <Typography variant="body1">{remainingTime}</Typography> */}
      <Typography variant='body2'>
        Expected Pending Response Time : 5 Working days
      </Typography>
      <Box mt={0} width="100%">
        <AnimatedLinearProgress variant="determinate" value={((5 - data?.Remaindays || 0) / 5) * 100} />
      </Box>
      <Box display="flex" justifyContent="space-between" width="100%" mb={1}>
        <Box display="flex" gap={1} alignItems="center">
          <Box width={10} height={10} bgcolor="#1a90ff" borderRadius="50%" mb={0} />
          {/* <Typography variant="body2">{elapsedTime}</Typography> */}
          <Typography variant="body2">{5 - data?.Remaindays || 0} day(s)</Typography>
        </Box>
        <Box display="flex" gap={1} alignItems="center">
          <Box width={10} height={10} bgcolor="#ffcccb" borderRadius="50%" mb={0} />
          {/* <Typography variant="body2">{remainingTime}</Typography> */}
          <Typography variant="body2">{data?.Remaindays || 0} day(s)</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CountdownProgressBar;
